var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-y-auto bg-gray-lightest",staticStyle:{"height":"calc(100vh - 56px)"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }